import { Select } from 'antd';

import cls from './varieties-input.module.css';

interface VarietiesInputProps {
  varieties: string[];
  onChange: (varieties: string[]) => void;
  labelWidth?: number;
}

export const VarietiesInput = ({ varieties, onChange, labelWidth }: VarietiesInputProps) => {
  const handleChange = (values: string[]) => {
    onChange(values);
  };

  return (
    <div className={cls.container}>
      <label
        className={cls.label}
        style={{ minWidth: labelWidth ? labelWidth : 164 }}
      >
        Varieties
      </label>
      <Select
        mode="tags"
        style={{ width: '100%' }}
        value={varieties || []}
        onChange={handleChange}
        className={cls.select}
        tokenSeparators={[',']}
      />
    </div>
  );
};

